/**
 * This module contains core features that are needed throughout the site and subsites
 * Add functionality here if it is needed in all subsites: palmia.fi, kallionkortteli.fi, ruoka.palmia.fi, vuosikatsaus
 */

import { branchBar } from '@crasman/branch-bar';
import navigation from './navigation';
import mailtoLinks from './mailto-links';
import newsList from './news-list';
import contactForm from './contact-form';
import cookieConsent from './cookie-consent';

// Polyfills
if(!Element.prototype.matches) {
  Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
}

branchBar.init();
navigation.init();
mailtoLinks.init();
newsList.init();
contactForm.init();
cookieConsent.init();
